import {
  createCountPipeline,
  createPagingStages,
  createSortStage,
  CustomPipelineFactory,
} from '@/providers/dataProvider';
import { aggregate } from '@/providers/backendClient';

const ARCHIVE_FILTER_HIDDEN = 'hidden';
const ARCHIVE_FILTER_VISIBLE = 'visible';
const ARCHIVE_FILTER_ONLY = 'only';

const buildArchiveMatch = (
  archiveFilter: string | undefined,
): Record<string, unknown> => {
  const value = archiveFilter ?? ARCHIVE_FILTER_VISIBLE;
  if (value === ARCHIVE_FILTER_VISIBLE) {
    return {};
  }
  if (value === ARCHIVE_FILTER_ONLY) {
    return { archivedAt: { $exists: true, $ne: null } };
  }
  return { archivedAt: null };
};

export const appGlobalAlertsCustomFetcher: CustomPipelineFactory =
  async ({ sort, filter = {}, page, perPage }) => {
    const archiveFilter = filter.archiveFilter as string | undefined;
    const matchStage = { $match: buildArchiveMatch(archiveFilter) };
    const sortStage = createSortStage(sort ?? { field: 'createdAt', order: 'DESC' });
    const pagingPipeline = createPagingStages(page, perPage);

    const resultsPipeline = [
      matchStage,
      sortStage,
      ...pagingPipeline,
    ];

    const countPipeline = createCountPipeline([matchStage]);

    const pipelines = {
      results: resultsPipeline,
      total: countPipeline,
    };

    const { results, total: [{ count = 0 } = {}] = [] } =
      (await aggregate('appGlobalAlerts', pipelines)) as {
        results: any[];
        total: { count: number }[];
      };

    return { results, total: count };
  };
